
<template>
  <div ref="date" class="ui input" :id="this.containerId">
    <input type="text" class="form-control input" :id="id" :name="name" :placeholder="placeholder" :readonly="readonly" :value="value" data-input />
    <span class="ui icon button calendar-icon" data-toggle :id="this.triggerId">
      <i class="fa fa-calendar" aria-hidden="true"></i>
    </span>
    <div class="bg-danger text-white col-12 clear-padding-left text-danger error-message" v-show="this.errors.hasKey(this.id)"><span class="" v-text="this.errors.getPropByKey('error', this.id)"></span></div>
  </div>
</template>
<script>
/* eslint-disable */
import flatpickr from "flatpickr";
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';
import yearDropdownPlugin from "@/utils/year_flatpickr_plugin";
import * as Validators from "@/utils/validators";
import moment from 'moment'
export default {
  name: "DateSelector",
  props: {
    name: String,
    id: String,
    value: {
      require: true
    },
    placeholder: String,
    readonly: Boolean,
    minDate: [String, Date],
    maxDate: [String, Date],
    yearStart: [String, Date],
    yearEnd: [String, Date],
    enableTime: { type: Boolean, default: () => false },    
    altDateFormat: { type: String, default: () => "d/m/Y" },        
    errors: { type: Array, default: () => [] },
  },

  data() {
    return {
      min: typeof this.minDate === "undefined" ? "" : this.minDate,
      max: typeof this.maxDate === "undefined" ? "" : this.maxDate,
      startYear: typeof this.yearStart === "undefined" ? "" : this.yearStart,
      endYear: typeof this.yearEnd === "undefined" ? "" : this.yearEnd,
      timeEnabled: typeof this.enableTime === "undefined" ? false : this.enableTime,
      dateFormat: typeof this.altDateFormat === "undefined" ? "d/m/Y" : this.altDateFormat,      
      
      ph: this.placeholder,
      containerId: this.id + "_container",
      triggerId: this.id + "_trigger"
    };
  },
  methods: {
    date() {
      return {
        datepicker: null
      };
    },
    handleDateChange(event) {
      this.$emit("update", event.target.id, event.target.value);
    },
    blur(value) {
      var index = this.errors.itemIndex(this.id);
      //TODO: valid date
      if (value == "" && index === -1) {
        this.addError();
      }
      else if (value != "" && index !== -1) {
        this.clearError();
      }
    },
    addError() {
      var index = this.errors.itemIndex(this.id);
      if (index === -1) {
        this.errors.push({ key: this.id, error: Validators.errorMessages.required });
      }
    },
    clearError() {
      var index = this.errors.itemIndex(this.id);
      if (index !== -1) {
        this.errorMessage = this.errors[index].error;
        this.errors.splice(index, 1);
        var element = document.getElementById(this.id);
        element.classList.remove("is-invalid");
      }
    },
    validDate(str) { //TODO: make extension
      return Object.prototype.toString.call(str) === "[object Date]";
    },
    validNumber(str){ //TODO: make extension
      return typeof (str) === 'number';
    }
  },
  mounted() {
    if (!this.datepicker) {
      var input = document.getElementById(this.containerId);

      if ((!this.validNumber(this.startYear) || this.validDate(this.startYear) )
        && (this.minDate !== null || typeof (this.minDate) !== 'undefined')) {
        this.startYear = this.validDate(this.minDate) ? this.minDate.getFullYear() : 
        this.validNumber(this.minDate) ? this.minDate : new Date().getFullYear();
      }
      if ((!this.validNumber(this.endYear) || this.validDate(this.endYear) )
        && (this.maxDate !== null || typeof (this.maxDate) !== 'undefined')) {
        this.endYear = this.validDate(this.maxDate) ? this.maxDate.getFullYear() : 
        this.validNumber(this.maxDate) ? this.maxDate : new Date().getFullYear();
      }

      if (input !== null) {
        this.datepicker = flatpickr(input, {
          plugins: [
            new yearDropdownPlugin({
              date: this.value,
              yearStart: this.startYear,
              yearEnd: this.endYear
            }),
            new ConfirmDatePlugin({})
          ],
          //"plugins": [new confirmDatePlugin({})]
          locale: {
            firstDayOfWeek: 1 // start week on Monday
          },
          wrap: true,
          enableTime: this.timeEnabled,
          time_24hr: true,
          dateFormat: "Z",
          altInput: true,
          altFormat: this.dateFormat, //"d/m/Y H:i"
          minDate: this.min,
          maxDate: this.max,
          onClose: function (selectedDates, dateStr, instance) {
            var date = moment(selectedDates[0], 'ddd MMM D YYYY HH:mm:ss ZZ').format('YYYY-MM-DDTHH:mm:ss.SSS');
            this.$emit('update', this.id, date)
            this.blur(dateStr);
          }.bind(this)
          //mode: "range"
        });
      }
    }
  },
  destroyed() {
    if (typeof (this.datepicker) !== undefined)
      this.datepicker.destroy();
  }
};
</script>
<style scoped>
.calendar-icon {
  position: absolute;
  top: 3px;
  right: 12px;
  margin: 0;
  height: 30px;
  line-height: 30px;
  padding: 0;
  border: none;
  background: none;
  color: #06397a;
  font-weight: 600;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 1.6em;
  cursor: pointer;
}
</style>
